<ng-template #modalLG let-modal style="border-radius: 8px">
    <div class="p-2">
        <span class="size18"> <strong>{{ documentType }} </strong> / <span style="color: #134AD3">{{ refExterne }}</span> </span>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="border-bottom: 1px solid #eee;"></div>
    <div class="">
        <div class="modal-body" tabindex="0" ngbAutofocus style="padding: 0 54px 64px">
            <div *ngIf="isLoading" class="text-center p-4">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Chargement...</span>
                </div>
            </div>
            
            <div *ngIf="!isLoading">
                <div class="d-flex justify-content-between">
                    <div class="mt-3 d-flex">
                        <div class="calendar">
                            <i data-feather="calendar" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-muted">{{ documentDate }}</span> <br>
                            <span class="text-black">Date</span>
                        </div>
                    </div>

                    <div class="mt-3 d-flex">
                        <div class="check">
                            <i data-feather="check" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-vert">{{ documentStatut }}</span> <br>
                            <span class="text-black">Statut</span>
                        </div>
                    </div>

                    <div style="margin-left: 16px;">
                        <div class="border-dashed rounded text-center total-box">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <strong class="size20"> {{ netPayer }} TND </strong>
                            </div>
                            <p class="size15 text-black">Montant total</p>
                        </div>
                    </div>
                </div>

                <h4 class="mx-1 mt-4 mb-3">Articles</h4>
                <div>
                    <table class="styled-table w-full mx-1 mb-2">
                        <thead>
                        <tr>
                            <th>PRODUIT</th>
                            <th>QUANTITÉ</th>
                            <th>REMISE</th>
                            <th>PRIX D'ACHAT</th>
                            <th>PRIX DE VENTE</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="lignesDocument.length === 0">
                            <td colspan="5" class="text-center text-muted">Aucun article</td>
                        </tr>
                        <tr *ngFor="let ligne of lignesDocument">
                            <td>{{ ligne.libelle }}</td>
                            <td>{{ ligne.qnt }}</td>
                            <td>{{ ligne.remise }}%</td>
                            <td>{{ (ligne.valeur_unitaire ?? ligne.prix_achat) ? formatPrice(ligne.valeur_unitaire ?? ligne.prix_achat) : '0.00' }} TND</td>
                            <td>{{ formatPrice(ligne.prix_ht) }} TND</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-end mt-3">
                    <div class="border-dashed rounded text-center benef-box">
                        <div class="mt-2 mb-1 benef-title">
                            <strong class="size20"> {{ calculateBenefice() }} TND</strong>
                        </div>
                        <p class="mb-1 size15">Bénéfice total</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
